import Icon from 'snippets/icon/icon'
import { FIELD_MAPPING } from '../helpers/universalSizeMapping'
import { RANGE_INDICATOR, PRICE_FILTER_FIELD } from './FilterUtils'

export function FilterSelected({ activeFilters, onRemove, onClear }) {
  if (!activeFilters || activeFilters.size === 0) return null

  return (
    <div class="flex flex-wrap items-center gap-2 p-4 md:px-0">
      {[...activeFilters].map((filter) => {
        const [handle, value] = filter.split(':')
        return (
          <btn
            class="flex h-8 cursor-pointer items-center gap-1 rounded-full bg-primary-grey px-4 pr-2 text-xs font-medium text-neutrals-secondary-grey"
            onClick={() => onRemove(filter)}
          >
            {getFilterLabel(handle, value)}{' '}
            <span>
              <Icon id="close" class="shrink-0 text-black" />
            </span>
          </btn>
        )
      })}
      <btn class="btn btn-text-black btn-sm shrink-0 underline" onClick={onClear}>
        Clear All
      </btn>
    </div>
  )
}

const getFilterLabel = (handle, value) => {
  if (FIELD_MAPPING[handle]) {
    return `${FIELD_MAPPING[handle]} ${value}`
  }

  if (value.includes(RANGE_INDICATOR)) {
    const [min, max] = value.split(RANGE_INDICATOR)
    const prefix = handle === PRICE_FILTER_FIELD ? '$' : ''
    return `${prefix}${min} - ${prefix}${max}`
  }
  return value
}
